import { render, staticRenderFns } from "./FormADV.vue?vue&type=template&id=22708564&scoped=true"
import script from "./FormADV.vue?vue&type=script&lang=js"
export * from "./FormADV.vue?vue&type=script&lang=js"
import style0 from "./FormADV.vue?vue&type=style&index=0&id=22708564&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22708564",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22708564')) {
      api.createRecord('22708564', component.options)
    } else {
      api.reload('22708564', component.options)
    }
    module.hot.accept("./FormADV.vue?vue&type=template&id=22708564&scoped=true", function () {
      api.rerender('22708564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/clientForms/FormADV.vue"
export default component.exports